import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import PropTypes from 'prop-types';
import React from 'react';
import { FlatList, View, StyleSheet, Keyboard, TouchableOpacity, Text } from 'react-native';
import LoadEarlier from './LoadEarlier';
import Message from './Message';
import Color from './Color';
import { warning } from './utils';
var styles = StyleSheet.create({
  container: {
    flex: 1
  },
  containerAlignTop: {
    flexDirection: 'row',
    alignItems: 'flex-start'
  },
  contentContainerStyle: {
    justifyContent: 'flex-end'
  },
  headerWrapper: {
    flex: 1
  },
  listStyle: {
    flex: 1
  },
  scrollToBottomStyle: {
    opacity: 0.8,
    position: 'absolute',
    paddingHorizontal: 15,
    paddingVertical: 8,
    right: 10,
    bottom: 30,
    zIndex: 999,
    height: 40,
    width: 40,
    borderRadius: 20,
    backgroundColor: Color.white,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: Color.black,
    shadowOpacity: 0.5,
    shadowOffset: {
      width: 0,
      height: 0
    },
    shadowRadius: 1
  }
});

var MessageContainer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MessageContainer, _React$PureComponent);

  function MessageContainer() {
    var _this;

    _classCallCheck(this, MessageContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MessageContainer).apply(this, arguments));
    _this.state = {
      showScrollBottom: false
    };

    _this.attachKeyboardListeners = function () {
      var invertibleProps = _this.props.invertibleScrollViewProps;

      if (invertibleProps) {
        Keyboard.addListener('keyboardWillShow', invertibleProps.onKeyboardWillShow);
        Keyboard.addListener('keyboardDidShow', invertibleProps.onKeyboardDidShow);
        Keyboard.addListener('keyboardWillHide', invertibleProps.onKeyboardWillHide);
        Keyboard.addListener('keyboardDidHide', invertibleProps.onKeyboardDidHide);
      }
    };

    _this.detachKeyboardListeners = function () {
      var invertibleProps = _this.props.invertibleScrollViewProps;
      Keyboard.removeListener('keyboardWillShow', invertibleProps.onKeyboardWillShow);
      Keyboard.removeListener('keyboardDidShow', invertibleProps.onKeyboardDidShow);
      Keyboard.removeListener('keyboardWillHide', invertibleProps.onKeyboardWillHide);
      Keyboard.removeListener('keyboardDidHide', invertibleProps.onKeyboardDidHide);
    };

    _this.renderFooter = function () {
      if (_this.props.renderFooter) {
        var footerProps = _objectSpread({}, _this.props);

        return _this.props.renderFooter(footerProps);
      }

      return null;
    };

    _this.renderLoadEarlier = function () {
      if (_this.props.loadEarlier === true) {
        var loadEarlierProps = _objectSpread({}, _this.props);

        if (_this.props.renderLoadEarlier) {
          return _this.props.renderLoadEarlier(loadEarlierProps);
        }

        return React.createElement(LoadEarlier, loadEarlierProps);
      }

      return null;
    };

    _this.scrollToBottom = function () {
      var animated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var inverted = _this.props.inverted;

      if (inverted) {
        _this.scrollTo({
          offset: 0,
          animated: animated
        });
      } else {
        _this.props.forwardRef.current.scrollToEnd({
          animated: animated
        });
      }
    };

    _this.handleOnScroll = function (event) {
      var _event$nativeEvent = event.nativeEvent,
          contentOffsetY = _event$nativeEvent.contentOffset.y,
          contentSizeHeight = _event$nativeEvent.contentSize.height,
          layoutMeasurementHeight = _event$nativeEvent.layoutMeasurement.height;
      var scrollToBottomOffset = _this.props.scrollToBottomOffset;

      if (_this.props.inverted) {
        if (contentOffsetY > scrollToBottomOffset) {
          _this.setState({
            showScrollBottom: true
          });
        } else {
          _this.setState({
            showScrollBottom: false
          });
        }
      } else {
        if (contentOffsetY < scrollToBottomOffset && contentSizeHeight - layoutMeasurementHeight > scrollToBottomOffset) {
          _this.setState({
            showScrollBottom: true
          });
        } else {
          _this.setState({
            showScrollBottom: false
          });
        }
      }
    };

    _this.renderRow = function (_ref) {
      var item = _ref.item,
          index = _ref.index;

      if (!item._id && item._id !== 0) {
        warning('GiftedChat: `_id` is missing for message', JSON.stringify(item));
      }

      if (!item.user) {
        if (!item.system) {
          warning('GiftedChat: `user` is missing for message', JSON.stringify(item));
        }

        item.user = {
          _id: 0
        };
      }

      var _this$props = _this.props,
          messages = _this$props.messages,
          user = _this$props.user,
          inverted = _this$props.inverted,
          restProps = _objectWithoutProperties(_this$props, ["messages", "user", "inverted"]);

      if (messages && user) {
        var previousMessage = (inverted ? messages[index + 1] : messages[index - 1]) || {};
        var nextMessage = (inverted ? messages[index - 1] : messages[index + 1]) || {};

        var messageProps = _objectSpread({}, restProps, {
          user: user,
          key: item._id,
          currentMessage: item,
          previousMessage: previousMessage,
          inverted: inverted,
          nextMessage: nextMessage,
          position: item.user._id === user._id ? 'right' : 'left'
        });

        if (_this.props.renderMessage) {
          return _this.props.renderMessage(messageProps);
        }

        return React.createElement(Message, messageProps);
      }

      return null;
    };

    _this.renderHeaderWrapper = function () {
      return React.createElement(View, {
        style: styles.headerWrapper
      }, _this.renderLoadEarlier());
    };

    _this.onLayoutList = function () {
      if (!_this.props.inverted && !!_this.props.messages && _this.props.messages.length) {
        setTimeout(function () {
          return _this.scrollToBottom(false);
        }, 15 * _this.props.messages.length);
      }
    };

    _this.keyExtractor = function (item) {
      return "".concat(item._id);
    };

    return _this;
  }

  _createClass(MessageContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.messages && this.props.messages.length === 0) {
        this.attachKeyboardListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.detachKeyboardListeners();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.messages && prevProps.messages.length === 0 && this.props.messages && this.props.messages.length > 0) {
        this.detachKeyboardListeners();
      } else if (prevProps.messages && this.props.messages && prevProps.messages.length > 0 && this.props.messages.length === 0) {
        this.attachKeyboardListeners();
      }
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(options) {
      if (this.props.forwardRef && this.props.forwardRef.current && options) {
        this.props.forwardRef.current.scrollToOffset(options);
      }
    }
  }, {
    key: "renderScrollBottomComponent",
    value: function renderScrollBottomComponent() {
      var scrollToBottomComponent = this.props.scrollToBottomComponent;

      if (scrollToBottomComponent) {
        return scrollToBottomComponent();
      }

      return React.createElement(Text, null, "V");
    }
  }, {
    key: "renderScrollToBottomWrapper",
    value: function renderScrollToBottomWrapper() {
      var _this2 = this;

      return React.createElement(View, {
        style: styles.scrollToBottomStyle
      }, React.createElement(TouchableOpacity, {
        onPress: function onPress() {
          return _this2.scrollToBottom();
        },
        hitSlop: {
          top: 5,
          left: 5,
          right: 5,
          bottom: 5
        }
      }, this.renderScrollBottomComponent()));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.messages || this.props.messages && this.props.messages.length === 0) {
        return React.createElement(View, {
          style: styles.container
        });
      }

      var inverted = this.props.inverted;
      return React.createElement(View, {
        style: this.props.alignTop ? styles.containerAlignTop : styles.container
      }, this.state.showScrollBottom && this.props.scrollToBottom ? this.renderScrollToBottomWrapper() : null, React.createElement(FlatList, _extends({
        ref: this.props.forwardRef,
        extraData: this.props.extraData,
        keyExtractor: this.keyExtractor,
        enableEmptySections: true,
        automaticallyAdjustContentInsets: false,
        inverted: inverted,
        data: this.props.messages,
        style: styles.listStyle,
        contentContainerStyle: styles.contentContainerStyle,
        renderItem: this.renderRow
      }, this.props.invertibleScrollViewProps, {
        ListFooterComponent: inverted ? this.renderHeaderWrapper : this.renderFooter,
        ListHeaderComponent: inverted ? this.renderFooter : this.renderHeaderWrapper,
        onScroll: this.handleOnScroll,
        scrollEventThrottle: 100,
        onLayout: this.onLayoutList
      }, this.props.listViewProps)));
    }
  }]);

  return MessageContainer;
}(React.PureComponent);

export { MessageContainer as default };
MessageContainer.defaultProps = {
  messages: [],
  user: {},
  renderFooter: null,
  renderMessage: null,
  onLoadEarlier: function onLoadEarlier() {},
  onQuickReply: function onQuickReply() {},
  inverted: true,
  loadEarlier: false,
  listViewProps: {},
  invertibleScrollViewProps: {},
  extraData: null,
  scrollToBottom: false,
  scrollToBottomOffset: 200,
  alignTop: false
};
MessageContainer.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object),
  user: PropTypes.object,
  renderFooter: PropTypes.func,
  renderMessage: PropTypes.func,
  renderLoadEarlier: PropTypes.func,
  onLoadEarlier: PropTypes.func,
  listViewProps: PropTypes.object,
  inverted: PropTypes.bool,
  loadEarlier: PropTypes.bool,
  invertibleScrollViewProps: PropTypes.object,
  extraData: PropTypes.object,
  scrollToBottom: PropTypes.bool,
  scrollToBottomOffset: PropTypes.number,
  scrollToBottomComponent: PropTypes.func,
  alignTop: PropTypes.bool
};